// extracted by mini-css-extract-plugin
export default {"activities":"ActivityStream_activities__csatj"};